import LoadingMixin from '../mixin'

export const movingLineProps = {}

export default {
  name: 'KLoadingMovingLine',
  mixins: [LoadingMixin],
  props: movingLineProps,
  data() {
    return {}
  },
  computed: {
    css() {
      return {
        'km-moving-line': true,
        [`km-moving-line--${this.type}`]: true,
        'km-moving-line--colorful': this.colorful,
      }
    },
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    renderLoading() {
      return (
        <div
          v-show={this.shouldShow}
          class={this.css}
        >
          <div class="km-moving-line__indicator" />
        </div>
      )
    },
  },
}
